/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Toast_UpdatedInputs */

const vi_vehicle_toast_updated = /** @type {(inputs: Vehicle_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật xe`)
};

/**

* @param {Vehicle_Toast_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_toast_updated = /** @type {((inputs?: Vehicle_Toast_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Toast_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_toast_updated(inputs)
});